/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Origine di una ricarica del servizio mensa (chi l\'ha creata).
 */
export enum OrigineRicarica {

    CITTADINO = 'CITTADINO',

    OPERATORE = 'OPERATORE',

    SISTEMA = 'SISTEMA'
}

